// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__8RKqV","noInteraction":"EventWrapper_noInteraction__1nTFe","pointerPassthrough":"EventWrapper_pointerPassthrough__2lcYS"};